"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Select = _interopRequireDefault(require("./Select.themeProps"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SelectOption = function SelectOption(_ref) {
  var children = _ref.children,
      isSelected = _ref.isSelected,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["children", "isSelected", "variant"]);

  return _react["default"].createElement(OptionContainer, _extends({
    isSelected: isSelected,
    variant: variant,
    type: "button"
  }, restProps), _react["default"].createElement("div", null, children));
};

var OptionContainer = _styledComponents["default"].button.withConfig({
  displayName: "SelectOption__OptionContainer",
  componentId: "sun3pk-0"
})(["display:block;width:100%;min-height:", ";margin:0 auto;padding:", " ", " ", " ", ";background-color:", ";border:none;text-align:left;font-family:", ";font-size:", ";cursor:pointer;transition:border-color 0.2s ease-out;display:flex;align-items:center;overflow:hidden;", ";&:hover,&:focus,&:active{outline:none;background-color:", ";}", ";"], _theming.targetSize.normal, _theming.spacing.tiny, _theming.spacing.mediumPlus, _theming.spacing.tiny, _theming.spacing.small, _theming.color.white, _theming.fontFamily.body(), _theming.font.input, function (p) {
  return p.isSelected && (0, _styledComponents.css)(["white-space:nowrap;border-radius:", ";> div{overflow:hidden;text-overflow:ellipsis;}"], _theming.borderRadius);
}, _theming.color.subtleHover, (0, _theming.applyVariants)(_Select["default"].optionContainer));

SelectOption.defaultProps = {
  isSelected: false
};
SelectOption.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  isSelected: _propTypes["default"].bool
};
var _default = SelectOption;
exports["default"] = _default;